import request from '@/utils/http';
// 查询列表
export const getOrdersApi = (params) => {
    return request({
        url: `/api-tms/transport/selectForMap`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 查询左侧列表
export const getLeftOrderList = (params) => {
    return request({
        url: `/api-tms/transport/selectPageForMap`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 查询订单明细
export const getOrderDetail = (data) => {
    return request({
        url: `/api-tms/transport/selectDetailForMap`,
        method: 'post',
        data
    }).then(res => res);
};

// 排车成功保存接口
export const saveCarArrange = (data) => {
    return request({
        url: `/api-tms/dispatch/artificial/save`,
        method: 'post',
        data
    }).then(res => res);
};

// 查询排车
export const getLinePlanQuery = (data) => {
    return request({
        url: `/api-tms/dispatch/driving/route/query`,
        method: 'post',
        data
    }).then(res => res);
};

// 发车单列表查询
export const getDispatchList = (params) => {
    return request({
        url: `/api-tms/dispatch/selectPageForMap`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 发车单明细表
export const getDispatchDetails = (params) => {
    return request({
        url: `/api-tms/transport/selectDispatchTransportForMap`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 根据发车单获取运输单
export const getTaskList = (data) => {
    return request({
        // url: `/api-tms/transportExtend/searchUnitInfo`,
        url: `/api-tms/transport/ext/query`,
        method: 'post',
        data
    });
};

// 供应商保存
export const getDispathOrderPreservation = (data) => {
    return request({
        url: `/api-tms/dispatch/updateeditdispatchinfo`,
        method: 'put',
        data
    });
};
// 整车排车时提示在途跟踪方式
export const promptTrackType = (data) => {
    return request({
        url: `/api-tms/dispatch/promptTrackType?dispatchNo=${data}`,
        method: 'post'
    });
};
// 加单
export const updateCarArrange = (data) => {
    return request({
        url: `/api-tms/transport/operate`,
        method: 'post',
        data
    });
};
// 减单
export const reduceApi = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/order/reduce`,
        method: 'post',
        data
    });
};

// 转移单下拉列表
export const getTargetRoot = (data) => {
    return request({
        url: `/api-tms/dispatch/selectForTransfer`,
        method: 'post',
        data
    }).then(res => res);
};

// 转移
export const transferApi = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/order/transfer`,
        method: 'post',
        data
    });
};

// 转移确认
export const getTransferData = (data) => {
    return request({
        url: `/api-tms/transport/transfer`,
        method: 'post',
        data
    }).then(res => res);
};

// 白名单接口
export const getWhiteListApi = (params) => {
    return request({
        url: `/api-opms/opms/whitelist/list`,
        method: 'get',
        params
    });
};

// 发车单商品明细查询
export const itemdeailCount = (data) => {
    return request({
        url: '/api-tms/transport/itemdeail/count',
        method: 'post',
        data
    });
};
